import axios from 'axios';
import { API_URL } from '../constant';

const API_BASE_URL = API_URL || 'https://staging.api.topcoinuk.com/api';

// Create axios instance with auth headers
const api = axios.create({
  baseURL: API_BASE_URL,
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const customerService = {
  // Get all customers with pagination and filters
  getAllCustomers: async (params = {}) => {
    const response = await api.get('/superadmin/customers', { params });
    return response.data;
  },

  // Get specific customer details
  getCustomer: async (userId) => {
    const response = await api.get(`/superadmin/customers/${userId}`);
    return response.data;
  },

  // Create new customer
  createCustomer: async (customerData) => {
    const response = await api.post('/superadmin/customers', customerData);
    return response.data;
  },

  // Update customer
  updateCustomer: async (userId, customerData) => {
    const response = await api.put(`/superadmin/customers/${userId}`, customerData);
    return response.data;
  },

  // Delete customer
  deleteCustomer: async (userId) => {
    const response = await api.delete(`/superadmin/customers/${userId}`);
    return response.data;
  },

  // Update customer status
  updateCustomerStatus: async (userId, statusData) => {
    const response = await api.post(`/superadmin/customers/${userId}/status`, statusData);
    return response.data;
  },

  // Get customer status history
  getCustomerStatusHistory: async (userId) => {
    const response = await api.get(`/superadmin/customers/${userId}/status-history`);
    return response.data;
  },

  // Get customer wallet details
  getCustomerWallet: async (userId) => {
    const response = await api.get(`/superadmin/customers/${userId}/wallet`);
    return response.data;
  },

  // Reset customer password
  resetCustomerPassword: async (userId, passwordData) => {
    const response = await api.post(`/superadmin/customers/${userId}/reset-password`, passwordData);
    return response.data;
  },

   getCustomerTransactionHistory: async (customerId, params = {}) => {
    try {
      const response = await api.get(`/superadmin/customers/${customerId}/transaction-history`, { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
    getCustomerSalesHistory: async (customerId, params = {}) => {
    try {
      const response = await api.get(`/superadmin/customers/${customerId}/sales-history`, { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

   getSalesDistribution: async (sbcRef) => {
    try {
      const response = await api.get(`/superadmin/sales/${encodeURIComponent(sbcRef)}/distribution`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
  
  checkEmailAvailability: async (email) => {
    try {
      const response = await api.post('/superadmin/customers/check-email-availability', { email });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  checkPhoneAvailability: async (phone) => {
    try {
      const response = await api.post('/superadmin/customers/check-phone-availability', { phone });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getCustomerCount: async (filters = {}) => {
    try {
      const response = await api.get('/superadmin/count/customers', {
        params: filters,
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching customer count:', error);
      throw error;
    }
  },
};

export const resolveCustomerRecord = (record) => {
  if (!record) return null;

  const customerId =
    record.customer_id ||
    record.Customer_id ||
    record.id;

  return {
    ...record,
    id: customerId,
    Customer_id: customerId,
    customer_id: customerId,
  };
};